import Vue, { CreateElement } from '@src/vue'

import { Component, Prop } from 'vue-property-decorator'

import './bullet.sass'

@Component
export class Bullet extends Vue {

  @Prop({ required: false })
  color: string

  render (h: CreateElement) {
    return <div class={`bullet ${this.color}`} />
  }

}
